import { render, staticRenderFns } from "./WeeklyParent.vue?vue&type=template&id=5fc58ef0"
import script from "./WeeklyParent.vue?vue&type=script&lang=js"
export * from "./WeeklyParent.vue?vue&type=script&lang=js"
import style0 from "./WeeklyParent.vue?vue&type=style&index=0&id=5fc58ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports